import request from "@/utils/request";

export default {
    getItems: async ({ commit, dispatch, state }, { fetchAll  = false, ...params }) => {
        if (fetchAll && state.list.length > 0) {
            return;
        }

        const url = fetchAll ? '/payment-types/all' : '/payment-types';
        const requestOptions = { method: 'get', url };

        if (!fetchAll) {
            Object.set(requestOptions, 'params', params);
        }

        await request({ ...requestOptions })
            .then(res => {
                if (res.data) {
                    commit('PROCESS_RES', res.data);
                }
            }).catch(error => {
                const message = error.response && error.response.data && error.response.data.error;

                if (message) {
                    dispatch('alert/addMessage', {
                        message
                    }, { root: true });
                }
            });
    }
};
